import { render } from "./SurveyReport.vue?vue&type=template&id=634949a2"
import script from "./SurveyReport.vue?vue&type=script&lang=js"
export * from "./SurveyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__